<mat-card class="department-container">
  <app-card-header-with-action
    i18n-title
    title="Department"
    (actionClicked)="onChangeDepartment()"
  ></app-card-header-with-action>

  @if (employee) {
    <div>
      <mat-list>
        <mat-list-item>
          <mat-icon matListItemIcon>business</mat-icon>
          <div matListItemTitle class="ns">
            {{
              employee.department
                ? DepartmentOption.getOption(employee.department)?.displayName
                : null
            }}
          </div>
        </mat-list-item>
      </mat-list>
    </div>
  }
</mat-card>
